// Původní název:		invia.GoogleMaps.initGoogleMaps, invia.GoogleMaps.getBoundsZoomLevel
// Původní umístění:	shared/js/invia-common.js
// #CHECKED jthiemel 181219

import $ from 'jquery';
import { invia, DomainId } from '@invia/web-library/invia';

const apiOptions = {
    v: '3.exp',
    key: 'XXX',
    sensor: false,
};

/**
 * @returns Promise
 */

export const initGoogleMaps = (options) => {
    var dfd = $.Deferred();

    if (typeof google === 'object' && typeof google.maps === 'object') {
        return dfd.resolve();
    } else {
        if (invia.domainId === DomainId.InviaCz) {
            apiOptions.key = 'AIzaSyBusbCMRcHoZZGS2zw3jCiD6mDKGCtVrd8';
        } else if (invia.domainId === DomainId.InviaSk) {
            apiOptions.key = 'AIzaSyAOMfyoSKxsUVdvPrqJ2tDSK85TjkBR8NY';
        } else if (invia.domainId === DomainId.InviaHu) {
            apiOptions.key = 'AIzaSyDisNI0SLCahxgVkK5hGaOPrLMlxXh0Vpw';
        } else if (invia.domainId === DomainId.TravelplanetPl) {
            apiOptions.key = 'AIzaSyA-EAQZgbVnixUuiEsKYoBhtKOoA4-YmsE';
        }

        options = options || {};
        var params = $.extend({}, apiOptions, options);
        var url = 'https://maps.googleapis.com/maps/api/js?' + $.param(params);

        $.getScript(url, function () {
            return dfd.resolve();
        });
    }

    return dfd.promise();
};

/**
 *
 * @param google.maps.LatLngBounds bounds
 * @param Object width, height
 * @returns int
 */

export const getBoundsZoomLevel = (bounds, mapDim) => {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin((lat * Math.PI) / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};
